"use strict";

var _regeneratorRuntime = require("/home/jfontirroig/pact/dappcrosscheck/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var elliptic_1 = require("elliptic");

var cryptoRandom_1 = require("./cryptoRandom");

var errors_1 = require("../errors");

var keys_1 = require("../keys");

var sha2Hash_1 = require("./sha2Hash");

var hmacSha256_1 = require("./hmacSha256");

var aesCipher_1 = require("./aesCipher");

var utils_1 = require("../utils");

var ecurve = new elliptic_1.ec('secp256k1');
/**
* @ignore
*/

function aes256CbcEncrypt(iv, key, plaintext) {
  return tslib_1.__awaiter(this, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee() {
    var cipher, result;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return aesCipher_1.createCipher();

          case 2:
            cipher = _context.sent;
            _context.next = 5;
            return cipher.encrypt('aes-256-cbc', key, iv, plaintext);

          case 5:
            result = _context.sent;
            return _context.abrupt("return", result);

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
}

exports.aes256CbcEncrypt = aes256CbcEncrypt;
/**
* @ignore
*/

function aes256CbcDecrypt(iv, key, ciphertext) {
  return tslib_1.__awaiter(this, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee2() {
    var cipher, result;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return aesCipher_1.createCipher();

          case 2:
            cipher = _context2.sent;
            _context2.next = 5;
            return cipher.decrypt('aes-256-cbc', key, iv, ciphertext);

          case 5:
            result = _context2.sent;
            return _context2.abrupt("return", result);

          case 7:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
}
/**
* @ignore
*/


function hmacSha256(key, content) {
  return tslib_1.__awaiter(this, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee3() {
    var hmacSha256;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return hmacSha256_1.createHmacSha256();

          case 2:
            hmacSha256 = _context3.sent;
            return _context3.abrupt("return", hmacSha256.digest(key, content));

          case 4:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
}
/**
* @ignore
*/


function equalConstTime(b1, b2) {
  if (b1.length !== b2.length) {
    return false;
  }

  var res = 0;

  for (var i = 0; i < b1.length; i++) {
    res |= b1[i] ^ b2[i]; // jshint ignore:line
  }

  return res === 0;
}
/**
* @ignore
*/


function sharedSecretToKeys(sharedSecret) {
  // generate mac and encryption key from shared secret
  var hashedSecret = sha2Hash_1.hashSha512Sync(sharedSecret);
  return {
    encryptionKey: hashedSecret.slice(0, 32),
    hmacKey: hashedSecret.slice(32)
  };
}
/**
 * Hex encodes a 32-byte BN.js instance.
 * The result string is zero padded and always 64 characters in length.
 * @ignore
 */


function getHexFromBN(bnInput) {
  var hexOut = bnInput.toString('hex', 64);

  if (hexOut.length === 64) {
    return hexOut;
  } else if (hexOut.length < 64) {
    // pad with leading zeros
    // the padStart function would require node 9
    var padding = '0'.repeat(64 - hexOut.length);
    return "".concat(padding).concat(hexOut);
  } else {
    throw new Error('Generated a > 32-byte BN for encryption. Failing.');
  }
}

exports.getHexFromBN = getHexFromBN;
/**
 * Returns a big-endian encoded 32-byte BN.js instance.
 * The result Buffer is zero padded and always 32 bytes in length.
 * @ignore
 */

function getBufferFromBN(bnInput) {
  var result = bnInput.toArrayLike(Buffer, 'be', 32);

  if (result.byteLength !== 32) {
    throw new Error('Generated a 32-byte BN for encryption. Failing.');
  }

  return result;
}

exports.getBufferFromBN = getBufferFromBN;
/**
 * Get details about the JSON envelope size overhead for ciphertext payloads.
 * @ignore
 */

function getCipherObjectWrapper(opts) {
  // Placeholder structure of the ciphertext payload, used to determine the 
  // stringified JSON overhead length. 
  var shell = {
    iv: '',
    ephemeralPK: '',
    mac: '',
    cipherText: '',
    wasString: !!opts.wasString
  };

  if (opts.cipherTextEncoding === 'base64') {
    shell.cipherTextEncoding = 'base64';
  } // Hex encoded 16 byte buffer.


  var ivLength = 32; // Hex encoded, compressed EC pubkey of 33 bytes.

  var ephemeralPKLength = 66; // Hex encoded 32 byte hmac-sha256.

  var macLength = 64;
  return {
    payloadValuesLength: ivLength + ephemeralPKLength + macLength,
    payloadShell: JSON.stringify(shell)
  };
}

exports.getCipherObjectWrapper = getCipherObjectWrapper;
/**
 * Get details about the JSON envelope size overhead for signed ciphertext payloads.
 * @param payloadShell - The JSON stringified empty `CipherObject`
 * @ignore
 */

function getSignedCipherObjectWrapper(payloadShell) {
  // Placeholder structure of the signed ciphertext payload, used to determine the 
  // stringified JSON overhead length. 
  var shell = {
    signature: '',
    publicKey: '',
    cipherText: payloadShell
  }; // Hex encoded DER signature, up to 72 byte length. 

  var signatureLength = 144; // Hex encoded 33 byte public key.

  var publicKeyLength = 66;
  return {
    signedPayloadValuesLength: signatureLength + publicKeyLength,
    signedPayloadShell: JSON.stringify(shell)
  };
}

exports.getSignedCipherObjectWrapper = getSignedCipherObjectWrapper;
/**
 * Fast function that determines the final ASCII string byte length of the
 * JSON stringified ECIES encrypted payload.
 * @ignore
 */

function eciesGetJsonStringLength(opts) {
  var _getCipherObjectWrapp = getCipherObjectWrapper(opts),
      payloadShell = _getCipherObjectWrapp.payloadShell,
      payloadValuesLength = _getCipherObjectWrapp.payloadValuesLength; // Calculate the AES output length given the input length. 


  var cipherTextLength = utils_1.getAesCbcOutputLength(opts.contentLength); // Get the encoded string length of the cipherText. 

  var encodedCipherTextLength;

  if (!opts.cipherTextEncoding || opts.cipherTextEncoding === 'hex') {
    encodedCipherTextLength = cipherTextLength * 2;
  } else if (opts.cipherTextEncoding === 'base64') {
    encodedCipherTextLength = utils_1.getBase64OutputLength(cipherTextLength);
  } else {
    throw new Error("Unexpected cipherTextEncoding \"".concat(opts.cipherTextEncoding, "\""));
  }

  if (!opts.sign) {
    // Add the length of the JSON envelope, ciphertext length, and length of const values.
    return payloadShell.length + payloadValuesLength + encodedCipherTextLength;
  } else {
    // Get the signed version of the JSON envelope
    var _getSignedCipherObjec = getSignedCipherObjectWrapper(payloadShell),
        signedPayloadShell = _getSignedCipherObjec.signedPayloadShell,
        signedPayloadValuesLength = _getSignedCipherObjec.signedPayloadValuesLength; // Add length of the JSON envelope, ciphertext length, and length of the const values. 


    return signedPayloadShell.length + signedPayloadValuesLength + payloadValuesLength + encodedCipherTextLength;
  }
}

exports.eciesGetJsonStringLength = eciesGetJsonStringLength;
/**
 * Encrypt content to elliptic curve publicKey using ECIES
 * @param publicKey - secp256k1 public key hex string
 * @param content - content to encrypt
 * @return Object containing:
 *  iv (initialization vector, hex encoding),
 *  cipherText (cipher text either hex or base64 encoded),
 *  mac (message authentication code, hex encoded),
 *  ephemeral public key (hex encoded),
 *  wasString (boolean indicating with or not to return a buffer or string on decrypt)
 * @private
 * @ignore
 */

function encryptECIES(publicKey, content, wasString, cipherTextEncoding) {
  return tslib_1.__awaiter(this, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee4() {
    var ecPK, ephemeralSK, ephemeralPK, sharedSecret, sharedSecretBuffer, sharedKeys, initializationVector, cipherText, macData, mac, cipherTextString, result;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            ecPK = ecurve.keyFromPublic(publicKey, 'hex').getPublic();
            ephemeralSK = ecurve.genKeyPair();
            ephemeralPK = Buffer.from(ephemeralSK.getPublic().encodeCompressed());
            sharedSecret = ephemeralSK.derive(ecPK);
            sharedSecretBuffer = getBufferFromBN(sharedSecret);
            sharedKeys = sharedSecretToKeys(sharedSecretBuffer);
            initializationVector = cryptoRandom_1.randomBytes(16);
            _context4.next = 9;
            return aes256CbcEncrypt(initializationVector, sharedKeys.encryptionKey, content);

          case 9:
            cipherText = _context4.sent;
            macData = Buffer.concat([initializationVector, ephemeralPK, cipherText]);
            _context4.next = 13;
            return hmacSha256(sharedKeys.hmacKey, macData);

          case 13:
            mac = _context4.sent;

            if (!(!cipherTextEncoding || cipherTextEncoding === 'hex')) {
              _context4.next = 18;
              break;
            }

            cipherTextString = cipherText.toString('hex');
            _context4.next = 23;
            break;

          case 18:
            if (!(cipherTextEncoding === 'base64')) {
              _context4.next = 22;
              break;
            }

            cipherTextString = cipherText.toString('base64');
            _context4.next = 23;
            break;

          case 22:
            throw new Error("Unexpected cipherTextEncoding \"".concat(cipherTextEncoding, "\""));

          case 23:
            result = {
              iv: initializationVector.toString('hex'),
              ephemeralPK: ephemeralPK.toString('hex'),
              cipherText: cipherTextString,
              mac: mac.toString('hex'),
              wasString: !!wasString
            };

            if (cipherTextEncoding && cipherTextEncoding !== 'hex') {
              result.cipherTextEncoding = cipherTextEncoding;
            }

            return _context4.abrupt("return", result);

          case 26:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
}

exports.encryptECIES = encryptECIES;
/**
 * Decrypt content encrypted using ECIES
 * @param {String} privateKey - secp256k1 private key hex string
 * @param {Object} cipherObject - object to decrypt, should contain:
 *  iv (initialization vector), cipherText (cipher text),
 *  mac (message authentication code), ephemeralPublicKey
 *  wasString (boolean indicating with or not to return a buffer or string on decrypt)
 * @return {Buffer} plaintext
 * @throws {FailedDecryptionError} if unable to decrypt
 * @private
 * @ignore
 */

function decryptECIES(privateKey, cipherObject) {
  return tslib_1.__awaiter(this, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee5() {
    var ecSK, ephemeralPK, sharedSecret, sharedSecretBuffer, sharedKeys, ivBuffer, cipherTextBuffer, macData, actualMac, expectedMac, plainText;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            ecSK = ecurve.keyFromPrivate(privateKey, 'hex');
            ephemeralPK = null;
            _context5.prev = 2;
            ephemeralPK = ecurve.keyFromPublic(cipherObject.ephemeralPK, 'hex').getPublic();
            _context5.next = 9;
            break;

          case 6:
            _context5.prev = 6;
            _context5.t0 = _context5["catch"](2);
            throw new errors_1.FailedDecryptionError('Unable to get public key from cipher object. ' + 'You might be trying to decrypt an unencrypted object.');

          case 9:
            sharedSecret = ecSK.derive(ephemeralPK);
            sharedSecretBuffer = getBufferFromBN(sharedSecret);
            sharedKeys = sharedSecretToKeys(sharedSecretBuffer);
            ivBuffer = Buffer.from(cipherObject.iv, 'hex');

            if (!(!cipherObject.cipherTextEncoding || cipherObject.cipherTextEncoding === 'hex')) {
              _context5.next = 17;
              break;
            }

            cipherTextBuffer = Buffer.from(cipherObject.cipherText, 'hex');
            _context5.next = 22;
            break;

          case 17:
            if (!(cipherObject.cipherTextEncoding === 'base64')) {
              _context5.next = 21;
              break;
            }

            cipherTextBuffer = Buffer.from(cipherObject.cipherText, 'base64');
            _context5.next = 22;
            break;

          case 21:
            throw new Error("Unexpected cipherTextEncoding \"".concat(cipherObject.cipherText, "\""));

          case 22:
            macData = Buffer.concat([ivBuffer, Buffer.from(ephemeralPK.encodeCompressed()), cipherTextBuffer]);
            _context5.next = 25;
            return hmacSha256(sharedKeys.hmacKey, macData);

          case 25:
            actualMac = _context5.sent;
            expectedMac = Buffer.from(cipherObject.mac, 'hex');

            if (equalConstTime(expectedMac, actualMac)) {
              _context5.next = 29;
              break;
            }

            throw new errors_1.FailedDecryptionError('Decryption failed: failure in MAC check');

          case 29:
            _context5.next = 31;
            return aes256CbcDecrypt(ivBuffer, sharedKeys.encryptionKey, cipherTextBuffer);

          case 31:
            plainText = _context5.sent;

            if (!cipherObject.wasString) {
              _context5.next = 36;
              break;
            }

            return _context5.abrupt("return", plainText.toString());

          case 36:
            return _context5.abrupt("return", plainText);

          case 37:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[2, 6]]);
  }));
}

exports.decryptECIES = decryptECIES;
/**
 * Sign content using ECDSA
 *
 * @param {String} privateKey - secp256k1 private key hex string
 * @param {Object} content - content to sign
 * @return {Object} contains:
 * signature - Hex encoded DER signature
 * public key - Hex encoded private string taken from privateKey
 * @private
 * @ignore
 */

function signECDSA(privateKey, content) {
  var contentBuffer = content instanceof Buffer ? content : Buffer.from(content);
  var ecPrivate = ecurve.keyFromPrivate(privateKey, 'hex');
  var publicKey = keys_1.getPublicKeyFromPrivate(privateKey);
  var contentHash = sha2Hash_1.hashSha256Sync(contentBuffer);
  var signature = ecPrivate.sign(contentHash);
  var signatureString = signature.toDER('hex');
  return {
    signature: signatureString,
    publicKey: publicKey
  };
}

exports.signECDSA = signECDSA;
/**
* @ignore
*/

function getBuffer(content) {
  if (content instanceof Buffer) return content;else if (content instanceof ArrayBuffer) return Buffer.from(content);else return Buffer.from(content);
}
/**
 * Verify content using ECDSA
 * @param {String | Buffer} content - Content to verify was signed
 * @param {String} publicKey - secp256k1 private key hex string
 * @param {String} signature - Hex encoded DER signature
 * @return {Boolean} returns true when signature matches publickey + content, false if not
 * @private
 * @ignore
 */


function verifyECDSA(content, publicKey, signature) {
  var contentBuffer = getBuffer(content);
  var ecPublic = ecurve.keyFromPublic(publicKey, 'hex');
  var contentHash = sha2Hash_1.hashSha256Sync(contentBuffer);
  return ecPublic.verify(contentHash, signature);
}

exports.verifyECDSA = verifyECDSA;